import { render, staticRenderFns } from "./partnerFooter.vue?vue&type=template&id=3342e088&scoped=true"
import script from "./partnerFooter.vue?vue&type=script&lang=js"
export * from "./partnerFooter.vue?vue&type=script&lang=js"
import style0 from "./partnerFooter.vue?vue&type=style&index=0&id=3342e088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3342e088",
  null
  
)

export default component.exports